import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const gdprPathMap = localizePathMap({
	[Locale.cs]: "ochrana-osobnich-udaju",
	[Locale.en]: "personal-data-protection",
});
